/* eslint-disable @typescript-eslint/no-unused-vars */

import { Navigate, Route, Routes } from 'react-router-dom';

import * as routing from '../../constants/Routing';
import { useRetrieveOrganization } from '../../hooks/organization/useRetrieveOrganization';
import { useRetrieveActiveProject } from '../../hooks/project/useRetrieveActiveProject';
import { useRetrieveUserCredentials } from '../../hooks/user/useRetrieveUserCredentials';

import { PlannerStopsContent } from './PlannerStopsContent';
import { PlannerStopsUnderGorilla } from './PlannerStopsUnderGorilla';
import { StopContextProvider } from './context';

export const SEARCH_LIMIT = 20;

export const PlannerStops = () => {
  const { data: userCredentials } = useRetrieveUserCredentials();
  const { data: organization } = useRetrieveOrganization();
  const { data: activeProject } = useRetrieveActiveProject();

  if (!activeProject || !organization) {
    return null;
  }

  if (!userCredentials?.subscription.test(`planner.stops`)) {
    return <PlannerStopsUnderGorilla />;
  }

  return (
    <StopContextProvider>
      <Routes>
        <Route index element={<Navigate to={routing.STOPS.LIST.replace(`:projectId`, activeProject?.id ?? ``)} />} />
        <Route path="/list" element={<PlannerStopsContent />} />
        <Route path="*" element={<Navigate to={routing.STOPS.LIST.replace(`:projectId`, activeProject?.id ?? ``)} />} />
      </Routes>
    </StopContextProvider>
  );
};
